export default {"src":"/_next/static/media/wpr.b5eddc0e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};